import { useCallback } from "react";
import { FieldValues, FieldPath, useFormContext } from "react-hook-form";

import { CheckboxInput } from "../CheckboxInput";
import { CheckboxInputGroup, CheckboxInputGroupProps } from "../CheckboxInputGroup";

type Props<Data extends FieldValues = FieldValues> = {
  name: FieldPath<Data>;
} & Omit<CheckboxInputGroupProps, "name">;

export const CheckboxControlGroup = <Data extends FieldValues = FieldValues>({
  name,
  inputLabel,
  ...props
}: Props<Data>) => {
  const { register, formState, getFieldState } = useFormContext<Data>();
  const fieldState = getFieldState(name, formState);

  const renderItem = useCallback((props: React.InputHTMLAttributes<HTMLInputElement>) => {
    return (
      <CheckboxInput
        {...props}
        {...register(name)}
        label={inputLabel}
      />
    );
  }, [name, inputLabel]);

  return (
    <CheckboxInputGroup
      {...props}
      renderItem={renderItem}
      invalid={!!fieldState.error}
      error={fieldState.error?.message}
    />
  );
};
